{
  "header": {
    "title": "Helpdesk",
    "description": "Charge-point fault reports and their handling."
  },
  "noAccess": {
    "title": "Access unavailable",
    "description": "Your access level could not be determined. Try again later."
  },
  "unavailable": {
    "title": "Helpdesk is not available",
    "description": "The helpdesk module is not available in this environment."
  },
  "filters": {
    "aria": "Filter reports",
    "status": "Status",
    "open": "Open",
    "urgent": "Urgent",
    "notForwarded": "Not forwarded",
    "resolved": "Resolved"
  },
  "table": {
    "title": "Reports",
    "count": "{{count}} report",
    "count_other": "{{count}} reports",
    "searchPlaceholder": "Search reports…",
    "searchAria": "Search reports",
    "columns": {
      "report": "Report",
      "chargePoint": "Charge point",
      "fault": "Fault",
      "status": "Status"
    },
    "empty": {
      "title": "No reports found",
      "description": "Adjust the filters or log a new report."
    },
    "error": {
      "title": "Couldn't load reports",
      "description": "Something went wrong loading the reports. Please try again."
    }
  },
  "actions": {
    "newReport": "New report",
    "cancel": "Cancel",
    "save": "Save",
    "edit": "Edit",
    "delete": "Delete",
    "forward": "Forward",
    "forwardAgain": "Forward again",
    "partnerResponse": "Partner response",
    "markResolved": "Mark resolved",
    "reopen": "Reopen"
  },
  "status": {
    "open": "Open",
    "resolved": "Resolved"
  },
  "catalog": {
    "faultType": {
      "offline": "Charge point offline",
      "noPower": "No power",
      "cableStuck": "Charging cable stuck",
      "cardNotRecognized": "Card not recognised",
      "cableBlocked": "Cable blocked",
      "faulted": "Status \"Faulted\" (red light)",
      "noOutput": "No output",
      "rfidFails": "RFID reads no cards",
      "screenCracked": "Screen cracked",
      "other": "Other"
    },
    "socket": {
      "socket1": "Socket 1",
      "socket2": "Socket 2",
      "both": "Both sockets",
      "all": "All sockets",
      "na": "N/A"
    },
    "snippet": {
      "noRemoteResponse": "Charge point does not respond remotely.",
      "resetPersists": "Reset remotely, the fault persists.",
      "customerNoPower": "Customer reports: no power, vehicle does not charge.",
      "offlineBackoffice": "Charge point offline in the backoffice.",
      "rfidNotRecognized": "RFID card is not recognised.",
      "cableStuckWaiting": "Charging cable is stuck, EV driver is waiting.",
      "bothOutOfUse": "Both sockets out of use.",
      "screenDefect": "Display or screen defective."
    }
  },
  "badges": {
    "urgent": "Urgent",
    "forwarded": "Forwarded",
    "notForwarded": "Not forwarded"
  },
  "form": {
    "addTitle": "New fault report",
    "editTitle": "Edit report #{{number}}",
    "description": "Record the charge point, the fault and any details for the service partner.",
    "sections": {
      "chargePoint": "Charge point & fault",
      "notes": "Notes",
      "reporter": "Reporter details"
    },
    "reporterHint": "Reporter details (EV driver). These are included when forwarding to the service partner.",
    "connectorOption": "Connector {{n}}",
    "fields": {
      "chargePointId": "Charging station ID",
      "chargePointLabel": "Alias",
      "operator": "Operator / service partner",
      "faultType": "Fault",
      "socket": "Socket",
      "location": "Location",
      "urgent": "Urgent (stuck cable / spoed)",
      "notes": "Notes",
      "reporterName": "Reporter name",
      "reporterPhone": "Phone number",
      "reporterEmail": "Email address"
    },
    "placeholders": {
      "chargePoint": "Search by station ID, name or location",
      "operator": "Choose an operator",
      "faultType": "Choose a fault",
      "socket": "Choose a socket",
      "notes": "Describe the fault, what has been tried, and any on-site details."
    },
    "errors": {
      "chargePointId": "A charge point ID is required.",
      "operator": "Choose an operator.",
      "faultType": "Choose a fault.",
      "location": "Location is required for an urgent report.",
      "reporterName": "Reporter name is required for an urgent report.",
      "reporterPhone": "Reporter phone number is required for an urgent report."
    }
  },
  "combo": {
    "loading": "Loading charging stations…",
    "noResults": "No charging station found. Adjust the search — reports can only be logged for stations in the list."
  },
  "forward": {
    "title": "Forward report #{{number}}",
    "description": "Send this report to the service partner by email.",
    "fields": {
      "to": "To",
      "cc": "CC",
      "priorityHint": "Priority indication (optional)"
    },
    "placeholders": {
      "to": "recipient@servicepartner.com, second@servicepartner.com",
      "cc": "cc@example.com",
      "priorityHint": "e.g. high / normal / low"
    },
    "priorityHintNote": "Optional. The service partner decides the final priority.",
    "confirm": "Send report",
    "recipientsNote": "Separate several addresses with a comma."
  },
  "partner": {
    "title": "Partner response · #{{number}}",
    "description": "Record what the service partner reported back.",
    "status": {
      "scheduled": "Technician scheduled",
      "resolved": "Fault resolved"
    },
    "fields": {
      "type": "Response type",
      "scheduledFor": "Scheduled for",
      "resolvedOn": "Resolved on",
      "note": "Note (optional)"
    },
    "placeholders": {
      "note": "For example: part ordered, technician coming in the morning."
    },
    "clear": "Clear response"
  },
  "detail": {
    "title": "Report #{{number}}",
    "fields": {
      "number": "Report number",
      "date": "Date",
      "chargePoint": "Charge point",
      "evse": "EVSE ID",
      "operator": "Operator",
      "faultType": "Fault",
      "socket": "Socket",
      "location": "Location",
      "route": "Route"
    },
    "sections": {
      "reporter": "Reporter",
      "notes": "Notes"
    },
    "forwardedTo": "Forwarded to {{email}} on {{date}}.",
    "notForwarded": "Not yet forwarded to the service partner.",
    "partnerResolved": "Service partner reported the fault resolved on {{date}}.",
    "partnerScheduled": "Service partner scheduled a technician for {{date}}."
  },
  "deleteDialog": {
    "title": "Delete report?",
    "description": "Report #{{number}} will be permanently removed.",
    "confirm": "Yes, delete"
  },
  "toasts": {
    "saved": "Report #{{number}} saved.",
    "saveFailed": "Could not save the report.",
    "deleted": "Report #{{number}} deleted.",
    "deleteFailed": "Could not delete the report.",
    "forwarded": "Report #{{number}} sent.",
    "forwardFailed": "Could not forward the report.",
    "partnerSaved": "Partner response recorded.",
    "partnerCleared": "Partner response cleared.",
    "forwardedNotSent": "Report #{{number}} recorded as forwarded, but the email was not sent: {{detail}}",
    "resolved": "Report #{{number}} marked resolved.",
    "reopened": "Report #{{number}} reopened.",
    "statusFailed": "Could not change the report status."
  },
  "contacts": {
    "title": "Notification contacts",
    "count": "{{count}} contact",
    "count_other": "{{count}} contacts",
    "hint": "These people are emailed as soon as a fault is reported on a charge point in their network.",
    "wholeNetwork": "{{name}} (whole network)",
    "columns": {
      "contact": "Contact",
      "target": "Applies to",
      "notify": "Notifications"
    },
    "notify": {
      "on": "On",
      "off": "Off"
    },
    "actions": {
      "add": "Add contact"
    },
    "empty": {
      "title": "No contacts yet",
      "description": "Add an email address to be notified about faults in your network."
    },
    "error": {
      "title": "Couldn't load contacts",
      "description": "Something went wrong loading the notification contacts. Please try again."
    },
    "form": {
      "addTitle": "New notification contact",
      "editTitle": "Edit contact",
      "description": "Who should hear about a fault reported on a charge point in this network.",
      "targetHint": "Choose your whole network, or a single organisation within it.",
      "emailHint": "One address per contact. Add another contact for a second address.",
      "notifyHint": "Switch off to keep the details on file without sending anything.",
      "fields": {
        "target": "Applies to",
        "name": "Name",
        "email": "Email address",
        "phone": "Phone number (optional)",
        "notify": "Email me about new fault reports"
      },
      "placeholders": {
        "name": "Person or team, e.g. Facility desk",
        "email": "name@company.com",
        "phone": "+31 6 12345678"
      },
      "errors": {
        "name": "A name is required.",
        "email": "Enter a valid email address."
      }
    },
    "deleteDialog": {
      "title": "Remove contact?",
      "description": "{{name}} will no longer be notified about faults.",
      "confirm": "Yes, remove"
    },
    "toasts": {
      "saved": "{{name}} saved.",
      "saveFailed": "Could not save the contact.",
      "deleted": "{{name}} removed.",
      "deleteFailed": "Could not remove the contact."
    }
  }
}
